export default __webpack_public_path__ + "static/MediaContentFive-69c49b788d5f5f6c45d0966aad206b2f.webp";